import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShowNavBarService {

  constructor() { }

  private showNavBar$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  setShowNavBar(show: boolean) {
    this.showNavBar$.next(show);
  }

  getShowNavBar(): Observable<boolean> {
    return this.showNavBar$.asObservable();
  }
  
}
